export default "/images/ebc5a67b27035f96c431756baf900cae.jpg";